import { Injectable } from '@angular/core';
import { DocumentMoveAuthTableConfig } from '@app/documents/models/document-move-auth-table-config.model';
import { ICoreAuthorizationDTO, ICoreMemberDTO, IDocumentResponseDTO } from '@core/model';
import { TableColumn } from '@mynexus/mynexus-ui-lib';
import { Observable, forkJoin } from 'rxjs';
import { AuthorizationPACService } from './authorization.service';
import { MemberPacService } from './member.service';
import { DocumentSource } from '@app/core/enumerations';

@Injectable({
  providedIn: 'root',
})
export class DocumentsMovePacService {
  constructor(
    private authorizationPacService: AuthorizationPACService,
    private memberPacService: MemberPacService,
  ) { }

  getAuthorizationTableConfig(): TableColumn[] {
    return [
      new TableColumn('Authorization Number', 'authorizationNumber', '10rem'),
      new TableColumn('MemberID', 'memberId', '9rem'),
      new TableColumn('Member Name', 'memberName', '9rem'),
      new TableColumn('Effective From', 'effectiveFromDate', '9rem'),
      new TableColumn('Effective To', 'effectiveToDate', '9rem'),
      new TableColumn('Auth Status', 'authorizationStatus', '8rem'),
      new TableColumn('Created On', 'createdOn', '8rem'),
      new TableColumn('Created By', 'createdBy', '8rem')
    ];
  }

  mapAuthorizationTableData(authorizationDto: ICoreAuthorizationDTO[], memberDto: ICoreMemberDTO): DocumentMoveAuthTableConfig[] {
    return authorizationDto.map(x => {
      return {
        authorizationNumber: x.authorizationNumber,
        memberId: memberDto?.subscriberNumber,
        memberName: memberDto ? `${memberDto.firstName} ${memberDto.lastName}` : '',
        effectiveFromDate: x.effectiveFromDate,
        effectiveToDate: x.effectiveToDate,
        authorizationStatus: x.authorizationStatus,
        createdOn: x.createdOn,
        createdBy: x.createdBy,
      }
    });
  }

  getMoveDocumentData(tenantId: string, newAuthorizationNumber: string): Observable<[ICoreAuthorizationDTO, ICoreMemberDTO]> {
    return forkJoin([
      this.authorizationPacService.getCoreAuthorization(tenantId, newAuthorizationNumber),
      this.memberPacService.getMemberByAuthNumber(tenantId, newAuthorizationNumber)
    ]);
  }

  filterDocuments(documents: IDocumentResponseDTO[]): IDocumentResponseDTO[] {
    return documents.filter(document => document.documentType !== 'NOMNC Rescind' && document.documentSource !== DocumentSource.Appeals);
  }
}
